"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBase32 = void 0;
const assertString_1 = require("./util/assertString");
const base32 = /^[A-Z2-7]+=*$/;
function isBase32(str) {
    (0, assertString_1.assertString)(str);
    const len = str.length;
    if (len % 8 === 0 && base32.test(str)) {
        return true;
    }
    return false;
}
exports.isBase32 = isBase32;
